import { render } from "./AddEditCategoryTemplateSlideOver.vue?vue&type=template&id=8d128e20"
import script from "./AddEditCategoryTemplateSlideOver.vue?vue&type=script&lang=ts"
export * from "./AddEditCategoryTemplateSlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script